// Copyright (c) StrangeBee 2023

import { IconLabel } from '@Atoms/Info';
import UserAvatar from '@Atoms/UserAvatar/UserAvatar';
import { useLocalMessage } from '@Helpers/locale';
import { THDatePicker } from '@Molecules/Inputs/THDatePicker/THDatePicker';
import { THEditable } from '@Molecules/Inputs/THEditable/THEditable';
import { THSelect } from '@Molecules/Inputs/THSelect/THSelect';
import { THTextArea } from '@Molecules/Inputs/THTextArea/THTextArea';
import { DisplayEventProps } from '@Organisms/Timeline/DisplayEvent';
import { EventCard } from '@Organisms/Timeline/EventCard';
import { useListAllUsers } from '@Queries/userQueries';
import React, { ReactElement } from 'react';

import './LogContent.scss';

export const LogContent = (props: DisplayEventProps): ReactElement => {
    const i = useLocalMessage();
    const { data: userList = [] } = useListAllUsers();
    const data = props.currentEvent.details?.log;
    const { includeInTimeline, message, _createdAt, _createdBy } = data || {};

    return (
        <EventCard {...props}>
            <div className="log-content card__content">
                {message && (
                    <THEditable
                        name="message"
                        className="card__header"
                        initialValues={{ message }}
                        label={i('common.description')}
                    >
                        <THTextArea disabled borderless />
                    </THEditable>
                )}
                {_createdBy && (
                    <THEditable
                        name="_createdBy"
                        className="card-info__user"
                        initialValues={{ _createdBy }}
                        label={i('common.created-by')}
                    >
                        <THSelect disabled borderless>
                            {userList?.map(({ _id, name, avatar, login }) => (
                                <THSelect.Option key={_id} value={login}>
                                    <IconLabel
                                        key={_id}
                                        icon={<UserAvatar name={name} avatar={avatar} />}
                                        label={name}
                                    />
                                </THSelect.Option>
                            ))}
                        </THSelect>
                    </THEditable>
                )}
                {_createdAt && (
                    <THEditable
                        name="_createdAt"
                        className="card-info__date"
                        initialValues={{ _createdAt }}
                        label={i('common.start-date')}
                    >
                        <THDatePicker disabled borderless />
                    </THEditable>
                )}
                {includeInTimeline && (
                    <THEditable
                        name="includeInTimeline"
                        className="card-info__date"
                        initialValues={{ includeInTimeline }}
                        label={i('task-log.create.includeInTimeline')}
                    >
                        <THDatePicker disabled borderless />
                    </THEditable>
                )}
            </div>
        </EventCard>
    );
};
